import { render, staticRenderFns } from "./TicketDynamicTab.vue?vue&type=template&id=6d9df99e&scoped=true&"
import script from "./TicketDynamicTab.vue?vue&type=script&lang=js&"
export * from "./TicketDynamicTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9df99e",
  null
  
)

export default component.exports